/**
 * 教室地図表示イベントを登録する
 */
function registDisplayKoushaMapEvent(){
	//重複登録されないようまずunbind
	$(document).off('click', '.js-fomeReco-check');
	// レコメンドチェックボックスの周りをクリックでチェック出来るようにする
	$(document).on('click', '.js-fomeReco-check', function(event) {
		if (event.target.tagName == 'TD') {
			$(this).children().children('input').click();
		}
	});
	$(document).on('click', '.js-add-cart', function(){
		_changeRecommendCheck($(this));
	});
	
		// 地図リンク押下でモーダルを開く
	$(document).on('click', '.js-map-link', function() {
		// クリックしたボタンと同じ要素のモーダルウィンドウを開く
		mapModalArea = $(this).parents('.js-reco-modal-window');
		// オーバーレイを表示
		mapModalArea.children('.js-reco-modal-window-box').fadeIn('fast', function() {
			// js-reco-modal-window-box-innerを画面中央に配置するための幅の調整
			mapModalArea.children('.js-reco-modal-window-box-inner').fadeIn();
			modalLeft = Math.floor((window.innerWidth - mapModalArea.children('.js-reco-modal-window-box-inner').width()) / 2);
			modalTop = Math.floor((window.innerHeight - mapModalArea.children('.js-reco-modal-window-box-inner').height()) / 2);
			mapModalArea.children('.js-reco-modal-window-box-inner').css({'top':modalTop, 'left':modalLeft });
			// スクロールさせない
			$('body').css('overflow', 'hidden');
		});
	});
	
	// オーバーレイクリックでモーダルウィンドウを閉じる
	$(document).on('click', '.js-reco-modal-window-box', function() {
		// モーダルが表示しきっていないと無効
		if ($('.js-reco-modal-window-box').is(':visible') && $('.js-reco-modal-window-box-inner').is(':visible')) {
			$('.js-reco-modal-window-box:visible').fadeOut();
			$('.js-reco-modal-window-box-inner:visible').fadeOut();
			$('body').css('overflow', 'auto');
		}
	});
	
	// 閉じるボタンでモーダルウィンドウを閉じる
	$(document).on('click', '.js-reco-modal-window-close', function() {
		$('.js-reco-modal-window-box').trigger('click');
	});
	
	// 各教室の位置情報から地図を取得
	$('.js-map-link').each(function(index){
		mapArea = $('.js-reco-modal-window').eq(index);
		let disp = mapArea.find('.map_canvas')[0];
		let lat = mapArea.children('.js-map-link').data('lat');
		let lon = mapArea.children('.js-map-link').data('lon');
		const mapModalCommon = new MapModalCommon(disp, lat, lon);
		mapModalCommon.loadKoushaMapDefaultPc();
	});
}

/**
 * 教室詳細モーダルイベントを登録する
 */
function registKoushaDetailModalEvent(){
	let KoushaDetailModal = {
		/** スクロール位置保存用 */
		_currentScrollY: 0,
		/** モーダルコンテンツ高さ、幅(%) */
		/** 教室モーダルは画面上部からの高さ(px)を指定 */
		KOUSHA_HEIGHT: 40,
		/** 教室モーダルは画面左部からの高さ(px)を指定 */
		KOUSHA_LEFT: 40,
		/** 
		 * モーダルを開く共通処理
		 * @param clickElement モーダルを開くボタン
		 * @param modalElement  モーダルの枠(class="js-modal-window")
		 * @param beforeFunc オーバーレイ表示前に実行する関数
		 * @param afterFunc オーバーレイ表示後に実行する関数
		 */
		open: function(clickElement, modalElement, beforeFunc, afterFunc) {
			// スクロール位置保存、固定
			this._lockScroll();
			// 前処理
			if (typeof(beforeFunc) === 'function') beforeFunc(clickElement, modalElement);
			// オーバーレイ表示
			modalElement.children('.js-kousha-detail-modal-window-over-ray').fadeIn('fast', function(){
				// 後処理
				if (typeof(afterFunc) === 'function') afterFunc(clickElement, modalElement);
			});
		},
		
		/** 
		 * モーダルを閉じる共通処理
		 * @param beforeFunc オーバーレイ非表示前に実行する関数
		 * @param afterFunc オーバーレイ非表示後に実行する関数
		 */
		close: function(beforeFunc, afterFunc) {
			// 前処理
			if (typeof(beforeFunc) === 'function') beforeFunc();
			// オーバーレイ非表示
			$('.js-kousha-detail-modal-window-over-ray:visible').fadeOut();
			// モーダルの中身非表示
			$('.js-kousha-detail-modal-window-box-inner:visible').fadeOut();
			// 後処理
			if (typeof(afterFunc) === 'function') afterFunc();
			// スクロール位置復元、固定解除
			this.unlockScroll();
		},
		
		/** 
		 * スクロール位置保存、固定
		 */
		_lockScroll: function() {
			this._currentScrollY = $(window).scrollTop();
			$('body').css('overflow', 'hidden');
		},
		
		/** 
		 * スクロール固定解除、位置復元
		 */
		unlockScroll: function() {
			$('body').css('overflow', '');
			$(window).scrollTop(this._currentScrollY);
		}
	};
		/** 教室モーダル 開くイベント */
	$(document).off('click', '.js-kousha-detail-modal-window-btn');
	$(document).on('click', '.js-kousha-detail-modal-window-btn', function(){
		KoushaDetailModal.open(
			$(this),
			$(this).closest('.js-kousha-detail-modal-window'),
			function(clickElement, modalElement){
				// loading画像表示
				if (typeof(_loadingDetailPopup) == 'function') {
					_loadingDetailPopup();
				}
				// データ取得
				let dataUrl = clickElement.data('url');
				$.ajax({
					type: 'POST',
					url: dataUrl,
					datatype: 'json',
					cache: false,
				}).done(function(data) {
					modalElement.find('.js-kousha-detail-modal-window-cont').html(data.response);
					// loading画像非表示
					$('body').find('.js-loading-popup').remove();
					// モーダルコンテンツ表示
					modalElement.children('.js-kousha-detail-modal-window-box-inner').show();
					// ajaxで取得するためイベントを再登録する
					trackEvent.bindEventOnElements(modalElement.find('.js-kousha-detail-modal-window-cont'));
					// 地図を表示
					_loadKoushaDetailModalMap(modalElement);
				}).fail(function () {
					$('body').find('.js-loading-popup').remove();
					$('.js-kousha-detail-modal-window-over-ray:visible').hide();
					// 失敗した場合はスクロールロックを解除
					KoushaDetailModal.unlockScroll();
					alert('データを取得できませんでした。');
				});
			},
			null
		);
	});
	
	
	/** 教室モーダル 閉じるイベント(オーバーレイ) */
	$(document).off('click', '.js-kousha-detail-modal-window-over-ray');
	$(document).on('click', '.js-kousha-detail-modal-window-over-ray', function(){
		if ($('.js-kousha-detail-modal-window-over-ray').is(':visible') && $('.js-kousha-detail-modal-window-box-inner').is(':visible') && $('body').find('.js-loading-popup').length === 0) {
			KoushaDetailModal.close();
		}
	});
	
	/** 教室モーダル 閉じるイベント(×ボタン) */
	$(document).off('click', '.js-modal-iframe-close');
	$(document).on('click', '.js-modal-iframe-close', function(){
		if ($('.js-kousha-detail-modal-window-over-ray').is(':visible') && $('.js-kousha-detail-modal-window-box-inner').is(':visible') && $('body').find('.js-loading-popup').length === 0) {
			KoushaDetailModal.close();
		}
	});
	
	// モーダルの内の問い合わせるボタン押下時に、資料請求チェックボタンを押下
	$(document).off('click', '.js-kousha-detail-modal-cv-kousha, .js-kousha-detail-modal-cv-tutor');
	$(document).on('click', '.js-kousha-detail-modal-cv-kousha, .js-kousha-detail-modal-cv-tutor', function(){
		let juku_id = $(this).data('juku_id');
		let tutor_id = $(this).data('tutor_id');

		// 対応するCVチェックボックスの要素を取得
		let targetCheckBox;
		if (juku_id) {
			targetCheckBox = $('input[id=js-check-juku-' + juku_id + '], input[id=js-default-check-juku-' + juku_id + ']');
		} else if (tutor_id) {
			targetCheckBox = $('input[id=tutor_' + tutor_id + ']')
		}

		// 現状チェックが付いていなかったら、チェックボックスの変更とカート追加処理を実行
		if(targetCheckBox.prop('checked') == false){
			// チェックを付ける
			targetCheckBox.prop('checked', true);
			// チェックボックスの画像を変更
			_changeRecommendCheck(targetCheckBox);

			// クリック時のデータのエレメントにて、カート処理(/cart/jquery.common.js)
			// ・イベント送信
			// ・カート追加
			// ・カートリストとレコメンドの再読み込み
			// デフォルトチェックでないときにカート追加する。※defaultCheckFlg(/cart/jquery.common.js)がtrueでないとき
			if(!(typeof defaultCheckFlg  !== 'undefined' && defaultCheckFlg)){
				_addCartHandler($(this));
			}
		}
		// モーダルを閉じる
		KoushaDetailModal.close();
	});
}

/**
 * チェックボックスの画像を変更する
 * @param {*} target 
 */
function _changeRecommendCheck(target) {
	let checkImg = target.parent().children('img');
	if (checkImg.attr('src') !== undefined) {
		let imgPath = checkImg.attr('src').split(/\.(?=[^.]+)/);
		let imgExt = imgPath.pop();//拡張子取り出し

		//既にパスに_onがついていた場合取り除く
		imgPath = imgPath.join('.').match(/(.*)_on/) ? imgPath.join('.').match(/(.*)_on/)[1] : imgPath.join('.');
		
		// チェックが付いていたら_onをつける
		if(target.is(':checked')){
			imgPath = imgPath + "_on";
		}
		checkImg.attr('src', imgPath + '.' + imgExt);
	}
}

/**
 * 詳細ポップアップのローディングを表示する
 */
function _loadingDetailPopup(){
	imgUrl = "/iphone/img2/loading_b.gif";
	// POPUPエレメント
	divObjBack = $("<div>").attr("class","cartRecommend-loading js-loading-popup").append($("<img>").attr("src", imgUrl));
	//オブジェクトを画面に追加
	$("body").append(divObjBack);
}

/**
 * モーダル内の教室詳細地図を読み込む
 */
function _loadKoushaDetailModalMap(modalElement){
	// 指定座標が無ければ、地図を作成しない。
	if (modalElement.find('input[class="kousha_detail_modal_lat"]').length == 0 || modalElement.find('input[class="kousha_detail_modal_lon"]').length == 0){
		return;
	}
	
	// 座標を取得
	let disp = modalElement.find('.js-map-canvas')[0];
	let lat = Number(modalElement.find('input[class="kousha_detail_modal_lat"]').val());
	let lon = Number(modalElement.find('input[class="kousha_detail_modal_lon"]').val());
	const mapModalCommon= new MapModalCommon(disp, lat, lon);
	mapModalCommon.loadKoushaMapDefaultPc();
}

/**
 * ページロード後に処理を走らせる
 */
$(function(){
	// カートマネージャー再設定
	if(typeof CartManager != 'undefined'){
		cart = new CartManager();
		cart.initialize();
	}
	
	registDisplayKoushaMapEvent();
	registKoushaDetailModalEvent();
});